import { ActionIcon, Menu } from '@mantine/core';
import { IconLanguage } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { applyDocumentDirection, type SupportedLanguage } from '../../i18n/init';

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();

  const change = async (next: SupportedLanguage) => {
    await i18n.changeLanguage(next);
    applyDocumentDirection(next);
  };

  return (
    <Menu position="bottom-end" withinPortal>
      <Menu.Target>
        <ActionIcon
          variant="subtle"
          color="gray"
          size="lg"
          aria-label={t('common.language')}
        >
          <IconLanguage size={18} stroke={1.6} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>{t('common.language')}</Menu.Label>
        <Menu.Item onClick={() => void change('ar')} disabled={i18n.language === 'ar'}>
          العربية
        </Menu.Item>
        <Menu.Item onClick={() => void change('en')} disabled={i18n.language === 'en'}>
          English
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
